<template>
    <div style="position: fixed; bottom: 0; left: 0; right: 0; padding: 20px; background: #01AD83;  color: white; z-index: 9999"
    v-if="cartCount" @click="openCart">
        <div style="display: flex;justify-content: space-between;">
            <span style="background-color: rgba(0, 0, 0, .10); min-width: 20px; min-height: 20px; border-radius: 4px; text-align: center;">{{ cartCount }}</span>
            <span class="text-center">{{ defaultCartLanguage.view_order }}</span>
            <span style="font-weight: bold;">€ {{ cartTotal.toFixed(2) }}</span>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
export default {
    computed: {
        ...mapGetters(['cartCount', 'cartTotal', 'defaultCartLanguage'])
    },

    methods: {
        ...mapActions(['openCart'])
    }
}
</script>
